import { parseDateTime } from '@Utils/transformDateTime';
import { LegalInfo } from '@Types/api/common/dictionary/LegalInfo';
import {
  EmploymentInformation,
  InsuranceDetails,
  PersonalInformation,
  VisaPassportInformation,
} from '../types';

interface UsePrepareCollapseDataProps {
  legalInfoData: LegalInfo;
}

interface ReturnValue {
  personalInformation: PersonalInformation;
  visaPassportInformation: VisaPassportInformation;
  employmentInformation: EmploymentInformation;
  insuranceDetails: InsuranceDetails;
}

const usePrepareCollapseData = ({
  legalInfoData,
}: UsePrepareCollapseDataProps): ReturnValue => {
  const personalInformation = {
    arabicName: legalInfoData.arabicName,
    arabicNationality: legalInfoData.arabicNationality,
    nationalId: legalInfoData.nationalId,
    nationIdExp: parseDateTime(legalInfoData.nationalIdExp),
  } as PersonalInformation;

  const visaPassportInformation = {
    passportNo: legalInfoData.passportNo,
    passportExp: parseDateTime(legalInfoData.passportExp),
    visaNo: legalInfoData.visaNo,
    visaExp: parseDateTime(legalInfoData.visaExp),
    visaFileNo: legalInfoData.visaFileNo,
    vfnIssueDate: legalInfoData.vfnIssueDate
      ? parseDateTime(legalInfoData.vfnIssueDate)
      : '',
  } as VisaPassportInformation;

  const employmentInformation = {
    laborCardNumber: legalInfoData.laborCardNo,
    laborCardExp: parseDateTime(legalInfoData.laborCardExp),
    molPersonNo: legalInfoData.molPersonalNo,
    sponsorComp: legalInfoData.sponsorComp,
    arabicDesignation: legalInfoData.visaDesignationArabic,
  } as EmploymentInformation;

  const insuranceDetails = {
    beneficiaryName: legalInfoData.insBeneficiaryName,
    insuranceProvider: legalInfoData.insProvider,
    insuranceCardNumber: legalInfoData.insCardNo,
    eligibility: legalInfoData.insEligibility,
    category: legalInfoData.insCategory,
    expDate: parseDateTime(legalInfoData.insExtDate),
  } as InsuranceDetails;

  return {
    personalInformation,
    visaPassportInformation,
    employmentInformation,
    insuranceDetails,
  };
};

export default usePrepareCollapseData;
